
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component({
  components: {
    PageBreadcrumbs: () => import('./PageBreadcrumbs.vue'),
  },
})
export default class SPage extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
    breadcrumbs?: any[];

  @Prop({
    type: Boolean,
    default: false,
  })
    isProduct!: boolean;

  @Prop({ type: String, required: false })
    title?: string;
}
